module.exports = __webpack_public_path__ + "img/rw.808f2593.svg";